import React, { useCallback } from "react";

const range = (start: number, end: number) => {
    let nums = [];
    for (let i = start; i <= end; i++) {
        nums.push(i);
    }
    return nums;
};

type Props = {
    page: number,
    total: number,
    setPage: (number: number) => void
}

export const Pagination = ({ page, total, setPage }: Props) => {

    const limit = 4, // use even number for the limit!
        halfRange = Math.floor(limit / 2);

    let links: Array<any> = [];

    if (total <= limit) {
        links = range(1, total);
    } else {

        if (page <= halfRange) {
            links = links.concat(range(1, limit + 1), [".."]);

        } else if (page >= total - halfRange + 1) {
            links = links.concat([".."], range(total - limit, total));

        } else {
            const start = page - halfRange;
            const end = page + halfRange;

            if (start > 1) {
                links.push("..");
            }

            links = links.concat(range(start, end));

            if (end < total) {
                links.push("..");
            }
        }
    }

    const nextPage = useCallback(() => {
        if (page < total) {
            setPage(page + 1);
        }
    }, [page, total]);

    const prevPage = useCallback(() => {
        if (page > 1) {
            setPage(page - 1);
        }
    }, [page]);

    return (
        <div aria-label="Pagination" className="so-pagination">
            <ul className="pagination">
                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                    {page === 1 ? (
                        <React.Fragment>
                            <span className="page-link">First</span>
                            <span className="page-link">Previous</span>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); setPage(1); }}>First</a>
                            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); prevPage(); }}>Previous</a>
                        </React.Fragment>
                    )}
                </li>

                {links.map((num, index) => (

                    <li className={`page-item ${page === num ? 'active' : ''}`} key={num === ".." ? "spacer" + index : index}>
                        {(page === num || num === "..") ? (
                            <span className="page-link disabled">{num}</span>
                        ) : (
                            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); setPage(num); }}>{num}</a>
                        )}
                    </li>

                ))}

                <li className={`page-item ${page === total ? 'disabled' : ''}`}>
                    {page === total ? (
                        <React.Fragment>
                            <span className="page-link">Next</span>
                            <span className="page-link">Last</span>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); nextPage(); }}>Next</a>
                            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); setPage(total); }}>Last</a>
                        </React.Fragment>
                    )}
                </li>
            </ul>
        </div>
    );
};

export default Pagination;
